var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetalles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804.3,46.7c19.5,0,34.2,14.7,34.2,34.2v838.3c0,19.6-14.7,34.2-34.2,34.2H195.7c-19.5,0-34.2-14.7-34.2-34.2V80.9c0-19.6,14.7-34.2,34.2-34.2H804.3 M804.3,10H195.7c-39.1,0-70.9,31.8-70.9,70.9v838.3c0,39.1,31.8,70.9,70.9,70.9h608.5c39.1,0,70.9-31.8,70.9-70.9V80.9C875.1,41.8,843.4,10,804.3,10L804.3,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.6,283.7c-29.3,0-51.3-22-51.3-51.3c0-29.3,22-51.3,51.3-51.3c29.3,0,51.3,22,51.3,51.3C471.9,259.3,447.5,283.7,420.6,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.1,405.9l-95.3-166.2c-4.9-9.8-14.7-14.7-24.4-14.7c-9.8,0-17.1,4.9-24.4,14.7l-58.7,85.5l0,0c-2.4,2.4-4.9,4.9-7.3,4.9c-2.4,0-4.9-2.4-7.3-2.4l0,0l-7.3-9.8c-7.3-7.3-14.7-9.8-24.4-9.8c-9.8,0-19.6,4.9-26.9,14.7L335,408.4c-4.9,9.8-4.9,19.5,0,29.3c4.9,9.8,14.7,14.7,24.4,14.7h278.6c12.2,0,19.6-4.9,24.4-14.7C665,425.5,665,415.7,660.1,405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.1,657.6h-391c-12.2,0-24.4-9.8-24.4-24.4c0-14.7,9.8-24.4,24.4-24.4h388.6c12.2,0,24.4,9.8,24.4,24.4C682.1,647.9,672.3,657.6,660.1,657.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.6,760.3H269.1c-12.2,0-24.4-9.8-24.4-24.4c0-14.7,9.8-24.4,24.4-24.4h322.6c12.2,0,24.4,9.8,24.4,24.4C616.1,750.5,603.9,760.3,591.6,760.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.6,853.1H269.1c-12.2,0-24.4-9.8-24.4-24.4s9.8-24.4,24.4-24.4h452.1c12.2,0,24.4,9.8,24.4,24.4S735.8,853.1,723.6,853.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalles);
export default __webpack_public_path__ + "static/media/detalles.40afae5532ac06e922614cda1092e512.svg";
export { ForwardRef as ReactComponent };